import styled from 'styled-components';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';
import {
    CloseButtonWrapper,
    Wrapper,
} from '@mlb/react-patterns/components/AnimatedModal/Header/header.style.tsx';
import { ContentWrapper } from '@mlb/react-patterns/components/AnimatedModal/animatedModal.style.tsx';

import Modal from 'bdvp-common/src/containers/Modal';

export const ModalWrapperOverride = styled(Modal)`
    background-color: transparent;
    border: none;

    @supports (margin-top: constant(safe-area-inset-top)) {
        --safe-area-inset-top: constant(safe-area-inset-top, 0);
        --safe-area-inset-bottom: constant(safe-area-inset-bottom, 0);

        height: calc(100% - var(--safe-area-inset-top) - var(--safe-area-inset-bottom))
        margin-top: var(--safe-area-inset-top);
        margin-bottom: var(--safe-area-inset-bottom);
    }

    @supports (margin-top: env(safe-area-inset-top)) {
        --safe-area-inset-top: env(safe-area-inset-top, 0);
        --safe-area-inset-bottom: env(safe-area-inset-bottom, 0);

        height: calc(100% - var(--safe-area-inset-top) - var(--safe-area-inset-bottom));
        margin-top: var(--safe-area-inset-top);
        margin-bottom: var(--safe-area-inset-bottom);
    }

    ${ Wrapper } {
        padding: 30px 14px;
    }

    ${ ContentWrapper } {
        height: 100%;
        padding-bottom: 20px;
    }

    ${CloseButtonWrapper} {
        button {
            display: block;
            position: absolute;
            top: 12px;
            right: 13px;

            &:hover {
                background-color: transparent;
            }

            svg {
                width: 25px;
                height: 25px;
            }

            ${media.smmax`
                @media (orientation: landscape) {
                    top: 30px;
                }
            `}
        }
    }
`;
